import { WarrantyDeflectionAction } from "../actions";
import { WarrantyDeflectionState } from "../types";

const REFRESH_REDUCERS = "REFRESH_REDUCERS";

const INITIAL_STATE: WarrantyDeflectionState = {
  loading: false,
  error: false,
  customerCalledOem: false,
};

export const warrantyDeflectionReducer = (
  state: WarrantyDeflectionState = INITIAL_STATE,
  action: WarrantyDeflectionAction | { type: typeof REFRESH_REDUCERS }
): WarrantyDeflectionState => {
  switch (action.type) {
    case "@@WarrantyDeflection/SUBMIT_ODOMETER_PARTIAL_SAVE_REQUEST":
    case "@@WarrantyDeflection/SUBMIT_CALL_OEM_PARTIAL_SAVE_REQUEST":
    case "@@WarrantyDeflection/SUBMIT_DECLINE_PARTIAL_SAVE_REQUEST":
      return { ...state, loading: true, error: false };
    case "@@WarrantyDeflection/SUBMIT_ODOMETER_PARTIAL_SAVE_SUCCESS":
    case "@@WarrantyDeflection/SUBMIT_DECLINE_PARTIAL_SAVE_SUCCESS":
      return { ...state, loading: false, error: false };
    case "@@WarrantyDeflection/SUBMIT_CALL_OEM_PARTIAL_SAVE_SUCCESS":
      return { ...state, loading: false, error: false, customerCalledOem: true };
    case "@@WarrantyDeflection/SUBMIT_ODOMETER_PARTIAL_SAVE_FAILED":
    case "@@WarrantyDeflection/SUBMIT_CALL_OEM_PARTIAL_SAVE_FAILED":
    case "@@WarrantyDeflection/SUBMIT_DECLINE_PARTIAL_SAVE_FAILED":
      return { ...state, loading: false, error: true };
    case REFRESH_REDUCERS:
      return { ...INITIAL_STATE };
    default:
      return state;
  }
};
